import { NavLink } from "react-router-dom";
import { useState } from "react";
import { load_porjects } from "../js/bay-checker.js";

export default function Bay_choice() {
	let the_projects = load_porjects();
	let current_project_id, current_bay_id;
	const [update, force_update] = useState(0);

	function rename_project(project_id) {
		console.log(project_id);
		console.log(the_projects);

		let new_project_name = document.getElementById("new_project_name");
		new_project_name.value = the_projects[project_id].project_title;

		let new_project_name_id = document.getElementById("new_project_name_id");
		new_project_name_id.value = project_id;

		document.getElementById("rename_overlay").classList.add("open");
	}

	function save_new_name() {
		let new_project_name = document.getElementById("new_project_name").value;
		let new_project_name_id = document.getElementById("new_project_name_id").value;

		the_projects[new_project_name_id].project_title = new_project_name;
		localStorage.setItem("the_projects", JSON.stringify(the_projects));

		document.getElementById("rename_overlay").classList.remove("open");
		force_update(Date.now());
	}

	function delete_project(project_id_to_delete) {
		if (window.confirm("Are you sure you want to delete?")) {
			//console.log(project_id_to_delete);

			let new_projects = the_projects.filter((project, project_id) => {
				if (project_id_to_delete != project_id) {
					return project;
				}
			});

			document.getElementById("project_" + project_id_to_delete).classList.remove("open");
			localStorage.setItem("the_projects", JSON.stringify(new_projects));
			the_projects = new_projects;

			force_update(Date.now());
		}
	}

	function view_bay_summery(project_id, bay_id) {
		current_project_id = project_id;
		current_bay_id = bay_id;

		document.getElementById("bay_summery_overlay").classList.add("open");

		document.getElementById("bay_details_title").innerHTML = the_projects[project_id].bays[bay_id].bay_title;
		document.getElementById("bay_details_type").innerHTML = the_projects[project_id].bays[bay_id].bay_type;
		document.getElementById("bay_details_summary").innerHTML = the_projects[project_id].bays[bay_id].bay_summary;
	}

	function delete_bay() {
		if (window.confirm("Are you sure you want to delete?")) {
			let new_bays = the_projects[current_project_id].bays.filter((bays, bay_id) => {
				if (current_bay_id != bay_id) {
					return bays;
				}
			});

			the_projects[current_project_id].bays = new_bays;

			document.getElementById("bay_summery_overlay").classList.remove("open");
			localStorage.setItem("the_projects", JSON.stringify(the_projects));

			force_update(Date.now());
		}
	}

	return (
		<div className="home max_width">
			<div className="header">
				<NavLink className="logo" to="/app/bay-checker/"></NavLink>
				<div className="info_button top">
					<div className="icon"></div>
					<div className="tool_tip">
						<h4>Bay Checker +</h4>
						<p>
							<strong>Bay checker +</strong> replaces and builds on the success of our original Bay Survey app.
						</p>
						<p>
							For <strong>Bay Windows</strong>, the same clever checking facility is built in to ensure that your{" "}
							<strong>measurements</strong> are correct.
						</p>
						<p>
							New for the version is a <strong>new design</strong> and easy to use interface. We store all of your
							projects locally on your app. We have also included straight poles, so that you can keep all elements of
							your project together.
						</p>
					</div>
				</div>
			</div>

			{the_projects.length == 0 && (
				<div className="nothing_yet">
					<h1>Nothing Yet</h1>
					<p>
						We don’t have anything saved. Try creating a new project now. Click{" "}
						<span
							onClick={() => {
								document.getElementById("site_menu_overlay").classList.add("open");
							}}
						>
							add new
						</span>{" "}
						below to start.
					</p>
				</div>
			)}

			{the_projects.length > 0 && (
				<ul className="project_list">
					<h1>Project List</h1>
					{the_projects.map((project, project_id) => {
						return (
							<li className="project_single" key={"project_id_" + project_id} id={"project_" + project_id}>
								<div className="actions">
									<span
										className="close_actions"
										onClick={(e) => {
											let li = document.getElementById("project_" + project_id);
											li.classList.toggle("open");
										}}
									></span>
									<span
										className="button light"
										onClick={() => {
											rename_project(project_id);
										}}
									>
										rename
									</span>
									<span
										className="button delete"
										onClick={() => {
											delete_project(project_id);
										}}
									>
										delete
									</span>
								</div>
								<div
									className="project_title"
									onClick={(e) => {
										let li = document.getElementById("project_" + project_id);
										li.classList.toggle("open");
									}}
								>
									<div className="box">
										<strong>{the_projects[project_id].bays.length}</strong>
										<span>items</span>
									</div>

									<h2>
										<span>Project name</span>
										{project.project_title}
									</h2>
								</div>

								{the_projects[project_id].bays.length > 0 && (
									<div className="dropdown">
										<ul>
											{the_projects[project_id].bays.map((bay, bay_id) => {
												return (
													<li
														key={"bay_" + bay_id + "_" + project_id}
														onClick={() => view_bay_summery(project_id, bay_id)}
													>
														<strong>{bay.bay_title} </strong>
														<span> - {bay.bay_type}</span>
													</li>
												);
											})}
										</ul>
									</div>
								)}
							</li>
						);
					})}
				</ul>
			)}

			<div id="rename_overlay" className="full_overlay">
				<span
					className="close"
					onClick={() => {
						document.getElementById("rename_overlay").classList.remove("open");
					}}
				></span>
				<div className="rename_content">
					<h3>Rename Project</h3>
					<p>Please choose a new project name.</p>
					<input id="new_project_name" name="project_new_name" maxLength="35" />
					<input type="hidden" id="new_project_name_id" name="project_new_name" />
					<p>
						<span
							className="button"
							onClick={() => {
								save_new_name();
							}}
						>
							Save new name
						</span>
					</p>
				</div>
			</div>

			<div id="site_menu_overlay" className="full_overlay">
				<div className="site_menu">
					<span
						className="close"
						onClick={() => {
							document.getElementById("site_menu_overlay").classList.remove("open");
						}}
					></span>
					<h3>
						Select <strong>Bay Type</strong>
					</h3>

					<ul>
						<li>
							<NavLink to="/app/bay-checker/straight-pole/">
								Straight <strong>Pole</strong>
							</NavLink>
						</li>
						<li>
							<NavLink to="/app/bay-checker/recess-pole/">
								Recess <strong>Pole</strong>
							</NavLink>
						</li>
						<li>
							<NavLink to="/app/bay-checker/one-bend/">
								One <strong>Bend Bay</strong>
							</NavLink>
						</li>
						<li>
							<NavLink to="/app/bay-checker/two-bend/">
								Two <strong>Bend Bay</strong>
							</NavLink>
						</li>
						<li>
							<NavLink to="/app/bay-checker/square-bend/">
								Square <strong>Bay</strong>
							</NavLink>
						</li>
						<li>
							<NavLink to="/app/bay-checker/four-bend/">
								Four <strong>Bend Bay</strong>
							</NavLink>
						</li>
						<li>
							<NavLink to="/app/bay-checker/continuous-curve/">
								Continuous <strong>Bend Bay</strong>
							</NavLink>
						</li>
					</ul>
				</div>
			</div>

			<div id="bay_summery_overlay" className="full_overlay">
				<div className="site_menu">
					<span
						className="close"
						onClick={() => {
							document.getElementById("bay_summery_overlay").classList.remove("open");
						}}
					></span>
					<h3>Bay Summary Overlay</h3>

					<div className="bay_summery_details">
						<div>
							<p>Bay Type</p>
							<h4 id="bay_details_type"> - type -</h4>
						</div>

						<div>
							<p>Bay Title</p>
							<h4 id="bay_details_title"> - name -</h4>
						</div>

						<div>
							<p>Bay Summary</p>
							<pre id="bay_details_summary">- Summary -</pre>
						</div>
					</div>

					<div className="actions">
						<span
							className="button light"
							onClick={() => {
								document.getElementById("bay_summery_overlay").classList.remove("open");
							}}
						>
							Close
						</span>{" "}
						<span className="button delete" onClick={() => delete_bay(1, 2)}>
							Delete Bay
						</span>
					</div>
				</div>
			</div>

			<div className="bottom_add_new">
				<div
					className="graphic"
					onClick={() => {
						document.getElementById("site_menu_overlay").classList.add("open");
					}}
				></div>
			</div>
		</div>
	);
}
